<template>
    <input type="time" placeholder="HH:mm" step="60" class="timeInputField" v-model="internalModel" />
</template>

<script>
export default {
    name: 'TimeInputField',

    model: {
        prop: 'outerModel'
    },

    props: {
        // nullable `type` needs custom `validator`
        // eslint-disable-next-line vue/require-prop-types
        outerModel: {
            required: true,
            validator: value => value === null || value instanceof Date
        }
    },

    computed: {
        internalModel: {
            get() {
                if (this.outerModel === null) {
                    return '';
                }
                const h = this.outerModel.getHours() + '';
                const m = this.outerModel.getMinutes() + '';
                const pad = str => str.padStart(2, '0');
                return pad(h) + ':' + pad(m);
            },
            set(value) {
                if (value) {
                    const parts = value.split(':');
                    const newDate = new Date(this.outerModel);
                    newDate.setHours(parseInt(parts[0], 10));
                    newDate.setMinutes(parseInt(parts[1], 10));
                    this.$emit('input', newDate);
                }
            }
        }
    }
};
</script>

<style lang="scss">
@import '../assets/styles/settings';

.timeInputField {
    width: 150px;
    padding: 6px 12px;
    font-size: 14px;
    font-family: inherit;
    border: 1px solid $color_gray_very_light;
    color: $color_gray_nero;
    background-color: $color_white;
    box-shadow: inset 0 1px 1px transparentBlack(0.075);
    border-radius: 4px;
}
</style>
